import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { GerinusService } from '../lib/gerinus.service';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable()
export class OrganizationService extends GerinusService {
    constructor(public http: HttpClient) {
        super(http);
        this.entityName = 'orgao';
        this.idField = 'OR_CodigoOrgao';
        this.model = 'OrgaoModel';
    }

    listOrganAndSubjects(): Observable<any> {
        return this.http.get(this.apiURL() + '/api/free/list-organ-and-subjects', this.headers());
    }

    public generateListReportPDF(title: string, condition: string) {
        const formData = new FormData();
        formData.append('title', title);
        formData.append('condition', condition);

        return this.http.post(
            this.apiURL() + '/api/pdf/organization-report-list', 
            formData, 
            { 
                ...this.headers(true), 
                responseType: 'blob', 
                reportProgress: true, 
                observe: 'events' 
            }
        );
    }
}
